export default {
  can: {}, // abilities from cancan
  cardTypes: [],
  defaultCards: [],
  defaultImages: [],
  userId: null,
  visualSchedule: {},
  visualScheduleSharing: {},
  directUploadUrl: '/rails/active_storage/direct_uploads',
  subtaskCounterOptions: [],
  templateOptions: [],
  displayOptions: [],
  visualScheduleChannel: null,
  updateVisualScheduleContent: false,
  updateImageRevealerContent: false,
};
